import { Component } from '@angular/core';

@Component({
  selector: '[hd-main-toolbar-chat]',
  templateUrl: './main-toolbar-chat.component.html',
  styleUrls: ['./main-toolbar-chat.component.scss']
})
export class MainToolbarChatComponent {}
